import { EntitlementKey, PLAN_CODE_BASIC, PLAN_CODE_BUSINESS, PLAN_CODE_PROFESSIONAL } from './entitlement-keys';
import { isProductTierDowngrade } from '../utils/billing-display.util';

export interface TargetPlanProfile {
  planCode: string;
  teamsMax: number | null;
  shiftsMax: number | null;
  companyEntitlements: ReadonlySet<string>;
}

const BASIC_ENTITLEMENTS = new Set<string>([
  EntitlementKey.employee_controlled_mode,
  EntitlementKey.website_usage,
  EntitlementKey.productivity_trends_preview,
  EntitlementKey.work_replay_preview,
  EntitlementKey.data_management_preview,
]);

const PROFESSIONAL_ENTITLEMENTS = new Set<string>([
  ...BASIC_ENTITLEMENTS,
  EntitlementKey.hidden_mode,
  EntitlementKey.manager_roles,
  EntitlementKey.multiple_shifts,
  EntitlementKey.advanced_tracking_controls,
  EntitlementKey.short_screenshot_interval,
  EntitlementKey.productivity_trends,
  EntitlementKey.work_replay,
  EntitlementKey.live_wall,
  EntitlementKey.live_screencast,
  EntitlementKey.data_management,
  EntitlementKey.device_management,
  EntitlementKey.bulk_settings_update,
  EntitlementKey.reports_advanced_filters,
  EntitlementKey.period_timesheet,
  EntitlementKey.screencast,
]);

const BUSINESS_ENTITLEMENTS = new Set<string>([
  ...PROFESSIONAL_ENTITLEMENTS,
  EntitlementKey.executive_reports,
  EntitlementKey.extended_retention,
]);

const PROFILES: Record<string, TargetPlanProfile> = {
  [PLAN_CODE_BASIC]: {
    planCode: PLAN_CODE_BASIC,
    teamsMax: 2,
    shiftsMax: 1,
    companyEntitlements: BASIC_ENTITLEMENTS,
  },
  [PLAN_CODE_PROFESSIONAL]: {
    planCode: PLAN_CODE_PROFESSIONAL,
    teamsMax: null,
    shiftsMax: null,
    companyEntitlements: PROFESSIONAL_ENTITLEMENTS,
  },
  [PLAN_CODE_BUSINESS]: {
    planCode: PLAN_CODE_BUSINESS,
    teamsMax: null,
    shiftsMax: null,
    companyEntitlements: BUSINESS_ENTITLEMENTS,
  },
};

export function getTargetPlanProfile(planCode: string | null | undefined): TargetPlanProfile {
  const code = String(planCode ?? PLAN_CODE_BASIC).toLowerCase();
  return PROFILES[code] ?? PROFILES[PLAN_CODE_PROFESSIONAL];
}

export function targetPlanHasEntitlement(
  profile: TargetPlanProfile,
  key: string
): boolean {
  return profile.companyEntitlements.has(String(key).toLowerCase());
}

export function requiresTransitionValidation(
  currentPlanCode: string,
  targetPlanCode: string
): boolean {
  return isProductTierDowngrade(currentPlanCode, targetPlanCode);
}
